import { Textarea } from "@platform/design-system";
import { Controller } from "react-hook-form";

import type { CustomFieldComponentProps } from "@platform/design-system";

const TextareaFieldComponent = ({
  field,
  methods,
}: CustomFieldComponentProps<"textarea">): React.JSX.Element => {
  const { customProps } = field;

  return (
    <Controller
      name={field.name}
      control={methods.control}
      defaultValue={field.defaultValue || ""}
      render={({ field: controllerField }) => (
        <Textarea
          {...controllerField}
          {...customProps}
          required={field.required ?? customProps?.required}
        />
      )}
    />
  );
};

export default TextareaFieldComponent;
